import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import { Modal } from "bootstrap";
import $ from "jquery";
import addbutton from "../static/images/add-button.png";
import xbutton from "../static/images/X_icon.png";

const Idiomas = ({ data, edit }) => {
  const [loading, setLoading] = useState(true);
  const [userIdiomas, setuserIdiomas] = useState([]);
  const [listIdiomas, setlistIdiomas] = useState([]);
  const [delIdiomas, setdelIdiomas] = useState("");

  useEffect(() => {
    let rol = localStorage.getItem("rol");
    if (data === undefined) {
      setLoading(true);
    } else {
      GetIdiomas();
    }
  }, [data]);

  useEffect(() => {
    if (data === undefined) {
      setLoading(true);
    } else {
      GetListIdiomas();
    }
  }, [userIdiomas]);

  function ConvertArray(list) {
    let array = [];
    let flag = true;
    list.map((item) => {
      if (!userIdiomas.find((i) => i.languageId === item.id)) {
        if (flag) {
          let op = {
            value: item.id,
            name: item.description,
          };
          op.value = "hidden";
          flag = false;
          array.push(op);
        }
        let op = {
          value: item.id,
          name: item.description,
        };
        array.push(op);
      }
    });
    setlistIdiomas(array);
    setLoading(false);
  }

  function GetIdiomas() {
    axios
      .get("applicant-languages/list-language-applicant/" + data)
      .then((result) => {
        setuserIdiomas(result.data);
      });
  }

  function GetListIdiomas() {
    axios.get("applicant-languages/list-language/").then((result) => {
      ConvertArray(result.data);
    });
  }

  function ValidateIdioma(id) {
    return listIdiomas.find((i) => i.languageId === id);
  }

  function GuardarIdioma(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    let id = ValidateIdioma(values.languageId);
    const exp = {
      applicantId: values.applicantId,
      applicantLanguagesId: values.languageId,
      languageId: values.languageId,
    };

    axios
      .post(
        "applicant-languages/create-applicantlanguage",
        JSON.stringify(exp),
        config
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetIdiomas();
          $("#agregar-idioma-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#agregar-idioma-modal").modal("hide");
      });
  }
  function FindIdioma(id) {
    setdelIdiomas(userIdiomas.find((i) => i.languageId === id));
  }
  function DeleteIdioma() {
    const exp = {
      applicantId: data,
      applicantLanguagesId: delIdiomas.languageApplicantId,
      languageId: delIdiomas.languageId,
    };

    axios
      .post("applicant-languages/delete-applicantlanguage", exp)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetIdiomas();
          $("#eliminar-idioma-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#eliminar-idioma-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    languageId: Yup.number().required("No puede estar vacio"),
  });

  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <Fragment>
          <div className="box left-col">
            <div className="head">
              <div className="title">Idiomas</div>
              {edit ? (
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#agregar-idioma-modal"
                >
                  <img src={addbutton} alt="Agregar Experiencia"></img>
                </a>
              ) : (
                ""
              )}
            </div>
            <div className="tags-cloud">
              <div className="tags-cloud__wrapper">
                {userIdiomas.map((item, index) => {
                  return (
                    <div>
                      {edit ? (
                        <div key={index} className="tag">
                          <span
                            className="cierre-X"
                            data-bs-toggle="modal"
                            data-bs-target="#eliminar-idioma-modal"
                            onClick={() => FindIdioma(item.languageId)}
                          >
                            <img src={xbutton} style={{ width: "20px" }}></img>
                          </span>
                          {item.idioma}
                        </div>
                      ) : (
                        <div key={index} className="tag">
                          {item.idioma}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div
            id="agregar-idioma-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <Formik
                    initialValues={{
                      applicantId: data,
                      applicantLanguagesId: 0,
                      languageId: 0,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      setSubmitting(true);
                      GuardarIdioma(values);
                      setSubmitting(false);
                    }}
                    validationSchema={Validaciones}
                  >
                    {({ errors, touched, isSubmitting }) => (
                      <Form>
                        <div className="mb-4 row">
                          <label htmlFor="languageId" className="col-sm-2 pe-0">
                            Idiomas
                          </label>
                          <div className="col-sm-10">
                            <Field
                              as="select"
                              id="languageId"
                              name="languageId"
                              required
                              className="form-select form-select-sm"
                            >
                              <option hidden selected>
                                Seleccione un Idioma
                              </option>
                              {listIdiomas.map((item, index) => {
                                if (item.value === "hidden") {
                                  return (
                                    <option key={index} hidden>
                                      Seleccione un Idioma
                                    </option>
                                  );
                                } else {
                                  return (
                                    <option key={index} value={item.value}>
                                      {item.name}
                                    </option>
                                  );
                                }
                              })}
                            </Field>
                            {errors.languageId && touched.languageId && (
                              <span className="form__validation form__validation--error">
                                {errors.languageId}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            data-bs-dismiss="modal"
                            className="btn btn--cancel"
                          >
                            Cancelar
                          </button>
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--small btn--purple"
                          >
                            <i className="fas fa-paper-plane"></i>Aceptar
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
      <div
        id="eliminar-idioma-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">Eliminar Idioma</div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteIdioma()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Idiomas;
